import { useSelector } from 'react-redux';
import {
  getCulinaryCollectiveFlags,
  getCenturionNetworkFlags,
} from '@/selectors/configSelectors';
import { convertStringFlagToList } from '@/helpers/featureFlagHelper';
import { supportedLocales } from '@/constants/supportedLocales';
import { useRouteParams } from '@/context/routeParamsContext';

export type Locale = Lowercase<(typeof supportedLocales)[number]>;

export const TclMigrationFeatures = {
  CENTURION_NETWORK_PAGE: 'CENTURION_NETWORK_PAGE',
  CULINARY_COLLECTIVE_PAGE: 'CULINARY_COLLECTIVE_PAGE',
} as const;

export type Features = keyof typeof TclMigrationFeatures;
type UseTclFeatureFlags = (feature: Features) => boolean;

export const useTCLFeatureFlags: UseTclFeatureFlags = (feature: Features) => {
  const { locale } = useRouteParams() as { locale: Locale };
  const culinaryCollectiveFlags: Locale = useSelector(
    getCulinaryCollectiveFlags
  );
  const centurionNetworkFlags: Locale = useSelector(getCenturionNetworkFlags);

  const featureFlags = {
    CULINARY_COLLECTIVE_PAGE: new Set<Locale>(
      convertStringFlagToList<Locale>(culinaryCollectiveFlags)
    ),
    CENTURION_NETWORK_PAGE: new Set<Locale>(
      convertStringFlagToList<Locale>(centurionNetworkFlags)
    ),
  };

  return featureFlags[feature].has(locale);
};
